import styled from "vue-styled-components";

export const ConnectButton = styled.div`
color: #000000 !important;
border: 2px solid #ffffff !important;
font-size: 20px !important;
font-weight: 600 !important;
background-color: #edf000 !important;
`;